




































/* eslint-disable vue/prop-name-casing */
import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';

import CardSection from '~/components/CardSection/CardSection.vue';
import Container from '~/components/Container.vue';
import VideoCard from '~/components/VideoCard/VideoCard.vue';

interface ILink {
  cached_url: string;
  url: string;
}

interface IBlogPost {
  content: {
    youtube_video: {
      content: {
        youtube_video_id: string;
      };
    };
    title: string;
    category: {
      name: string;
    };
    author: {
      name: string;
    };
    description: string;
    banner: {
      filename: string;
      alt: string;
    };
  };
  full_slug: string;
}

export default defineComponent({
  name: 'VideoGrid',
  components: {
    CardSection,
    VideoCard,
    Container,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    link: {
      type: Object as PropType<ILink>,
      default: () => ({}),
    },
    link_text: {
      type: String,
      default: '',
    },
    videos: {
      type: Array as PropType<IBlogPost[]>,
      default: () => [],
    },
  },
  setup(props) {
    const linkUrl = computed(() => `/${props.link.cached_url || props.link.url || ''}`);

    function getYoutubeVideoURL(video: IBlogPost) {
      const id = video.content.youtube_video.content.youtube_video_id;

      return `https://www.youtube.com/embed/${id}`;
    }

    function isYoutubeVideo(video: IBlogPost) {
      return !!video.content?.youtube_video?.content?.youtube_video_id;
    }

    return {
      linkUrl,
      getYoutubeVideoURL,
      isYoutubeVideo,
    };
  },
});
